import withClassName from './withClassName'

const withDisabled = disabledStyleClassName =>
  withClassName(props => props.disabled, disabledStyleClassName)

export default withDisabled
